import { defineComponent } from 'vue';
export default defineComponent({
    name: 'Checkbox',
    props: {
        checked: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:checked'],
    methods: {
        emitUpdate() {
            this.$emit('update:checked', !this.checked);
        },
    },
});
